<p-toast class="toast_on_top"></p-toast>
<header class="bg-dark">
  <div class="top-bar-logo cursor-pointer" [routerLink]="['/home']" routerLinkActive="router-link-active">
    <img src="../assets/icons/deloitte.svg" />
    <span class="font-bold text-bluegray-50">{{ title }}</span>
  </div>
  <div class="top-bar-nav-links pr-2">
    @if (loginDisplay) {
    <!-- this is for smaller screens -->
    <div class="block sm:hidden">
      <p-button icon="pi pi-bars" (click)="this.overlayVisible = !this.overlayVisible"></p-button>
    </div>
    <p-overlay #overlay_Options [(visible)]="overlayVisible">
      <ng-template pTemplate="content" let-option>
        <div class="bg-dark overlay_styles">
          <p-menu [model]="navigation_items"></p-menu>
        </div>
      </ng-template>
    </p-overlay>

    <!-- this is for bigger screens -->
    <div class="hidden sm:block">
      <div class="flex align-items-center gap-6">
        <p-tabMenu [model]="navigation_items" [activeItem]="activeItem"></p-tabMenu>
        <div class="flex align-items-center gap-1" (click)="logoutMenu.toggle($event)">
          <div (click)="logoutMenu.toggle($event)" class="cursor-pointer avatar"
            [ngClass]="{ 'avatar-flex': !commonservice.logged_in_user_image }" id="avatar">
            @if (commonservice.logged_in_user_image) {
            <img [src]="commonservice.logged_in_user_image" />
            }
          </div>
          <span>
            {{ loggedin_profile?.displayName }}
          </span>
        </div>
      </div>
    </div>
    }
  </div>
</header>
<p-menu #logoutMenu [model]="logout_items" [popup]="true"></p-menu>

<app-loading-indicator [detectRouteTransitions]="true"></app-loading-indicator>

<div class="container">
  @if (!isIframe) { @if (!loginDisplay) {
  <div class="main-content">
    <app-login></app-login>
  </div>
  }@else {
  <main>
    <div class="back-btn cursor-pointer" *ngIf="!isHome">
      <i class="pi pi-arrow-left text-2xl" (click)="navigate_back()"></i><span (click)="navigate_back()">
        &nbsp; Back to {{ previous_route | async }}
      </span>
    </div>
    <router-outlet></router-outlet>
  </main>
  } }
</div>